import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const PrivateRoute = ({ children }) => {
  const { token } = useAuth();

  useEffect(() => {
    if (!token) {
      alert("Sua sessão expirou ou você não está logado. Por favor, entre novamente.");
    }
  }, [token]);

  if (!token) {
    // Redireciona para login se não houver token
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;